import { MtsResponse } from '@/store/slices/it-process/application-management/mts/mtsSlice'

/**
 * Client-side source of truth for the header (MTS) action items.
 *
 * These used to be fetched per business-administration from `GET api/screen/mts`.
 * That request has been removed; the items are now hardcoded here so the header
 * renders the exact same icons in the exact same order on every load, with no
 * network round-trip.
 *
 * IMPORTANT
 *  - `name` and `id` must stay identical to what the backend returned, because
 *    translated tooltips are still fetched (`getMtsTokens`) and patched onto these
 *    items by matching on `key === id` or `key === name` (see updateTokensInMtsList).
 *  - Items are rendered sorted by `order` (ascending).
 *  - `icon` is resolved by IconComponent, which only loads the Hi / Io / Vsc
 *    react-icons sets.
 *
 * NOTE: values below are a PLACEHOLDER inferred from the reference attachment.
 * Replace with the verbatim `api/screen/mts` JSON to guarantee an exact match.
 */
export const MTS_HEADER_ITEMS: MtsResponse[] = [
    {
        id: 1,
        name: 'Distribution',
        icon: 'HiOutlineShare',
        order: 1,
        businessAdministrationId: 0,
    },
    {
        id: 2,
        name: 'Mail',
        icon: 'HiOutlineMail',
        order: 2,
        businessAdministrationId: 0,
    },
    {
        id: 3,
        name: 'Notifications',
        icon: 'HiOutlineBell',
        order: 3,
        businessAdministrationId: 0,
    },
]

export default MTS_HEADER_ITEMS
